import { TweenMax, TimelineMax, Expo } from 'gsap';

export function staggerListInit(el) {
  const ctx = el instanceof HTMLElement ? el : el.node;
  const elsToTween = Array.from(ctx.querySelectorAll('li'));

  TweenMax.set(elsToTween, {
    autoAlpha: 0,
    y: 50,
  });

  return el;
}

export function staggerListAnim(el) {
  const ctx = el instanceof HTMLElement ? el : el.node;
  const elsToTween = Array.from(ctx.querySelectorAll('li'));
  const tl = new TimelineMax();

  tl.addLabel('start')
    .staggerTo(elsToTween, 1, {
      autoAlpha: 1,
      y: 0,
      ease: Expo.easeOut,
      clearProps: 'all',
    }, 0.2, 'start');

  return tl;
}
